import { CloseOutlined, EditFilled, PlusCircleFilled } from '@ant-design/icons'
import {
  Button,
  Col,
  DatePicker,
  Drawer,
  Form,
  FormInstance,
  Input,
  Row,
  Select,
  Space,
} from 'antd'
import { FooterDiv } from './NewNurseViewStyle'
import NurseForm from '../Forms/NurseForm/NurseForm'

type Props = {
  open: boolean
  onClose: () => void
  form: FormInstance<any>
  updateState: boolean
  onFinish: () => void
}

const NewNurseView = ({
  onClose,
  open,
  form,
  onFinish,
  updateState,
}: Props) => {
  return (
    <>
      <Drawer
        title={
          <>
            {updateState ? (
              <>
                <EditFilled style={{ fontSize: '24px' }} />
                Update Nurse
              </>
            ) : (
              <>
                <PlusCircleFilled style={{ fontSize: '24px' }} /> Register Nurse
              </>
            )}
          </>
        }
        width='60vw'
        onClose={onClose}
        closeIcon={false}
        open={open}
        extra={
          <Space>
            <Button shape='circle' type='text' onClick={onClose}>
              <CloseOutlined />
            </Button>
          </Space>
        }
      >
        <NurseForm
          updateState={updateState}
          disabledState={false}
          form={form}
          onFinish={onFinish}
        />
        <FooterDiv>
          <Space>
            <Button onClick={onClose}>Cancel</Button>
            <Button onClick={() => form.submit()} type='primary'>
              {updateState ? 'Update' : 'Register'}
            </Button>
          </Space>
        </FooterDiv>
      </Drawer>
    </>
  )
}

export default NewNurseView
